import React, { Component } from 'react';

class CarouselItem extends Component {
  render() {
    return (
      <div className={`carousel-item ${this.props.active ? 'active' : ''}`}>
        <div className="view">
          <img className="d-block w-100" src="assets/img-bg.png" alt="First slide" />
          <div className="flex-center mask">
            <div className="hero_content animated fadeInDown col-md-10 list-unstyled list-inline">
              <div className="col-md-12 p-0">
                <h1 className="hello_hero h1-responsive">Saudaraku,</h1>
                <h2 className="hero_title h2-responsive text-capitalize">Ayo <strong>Bangun masjid di surga.</strong></h2>
              </div>
              <div className="col-md-6 p-0">
                <blockquote className="quote_hero lead mt-4">"Siapa yang membangun masjid karena Allah, maka Allah akan membangun baginya semisal itu di surga."</blockquote>
                <em className="quote_hero--secondary">(HR. Bukhari no. 450 dan Muslim no. 533).</em>
              </div>
              <div className="col-md-3 p-0 mt-5">
                <button type="button" className="btn-donasi text-uppercase">Donasi</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CarouselItem;



// WEBPACK FOOTER //
// ./src/components/CarouselItem.js